import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { PROJECT_TYPE_CHANGED, type ProjectTypeChangedAction } from '../state/actions.tsx';
import { getAppProps } from '../state/selectors.tsx';
import type { State } from '../state/types.tsx';

export const projectTypeChanged = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action$: ActionsObservable<any>,
	store: MiddlewareAPI<State>, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<any> =>
	action$.ofType(PROJECT_TYPE_CHANGED).mergeMap((action: ProjectTypeChangedAction) => {
		const { onChange } = getAppProps(store.getState());
		onChange(action.payload, action.meta.analyticsEvent);
		return Observable.empty<never>();
	});
